module.exports = __webpack_public_path__ + "media/images/Just-Wick-554b3603d6ebdca2251ea17fef50cbbd.png";